import { Avatar } from '@/components/Avatar/Avatar'
import CloseSvg from '@/icons/close.svg?react'
import { useCommitsState } from '@/state/commits'
import { useGeneratorState } from '@/state/generator'
import type { FunctionalComponent } from 'preact'
import { useShallow } from 'zustand/shallow'
import styles from './index.module.scss'

export const GeneratorCommit: FunctionalComponent<{
  disabled?: boolean
  repoId: number
  sha: string
}> = props => {
  const commitItem = useCommitsState(useShallow(s =>
    s.byRepoId[props.repoId]?.list
      .find(item => item.commit.sha === props.sha)
  ))

  const toggleCommit = useGeneratorState(s => s.toggleCommit)

  if (!commitItem) {
    return null
  }

  return (
    <div class={styles.item}>
      {commitItem.commit.author?.avatar_url && (
        <Avatar
          size={16}
          src={commitItem.commit.author.avatar_url}
        />
      )}
      <div class={styles.message}>
        {commitItem.commit.commit.message}
      </div>
      <button
        disabled={props.disabled}
        class={styles.close}
        onClick={() => {
          toggleCommit(props.repoId, props.sha)
        }}
      >
        <CloseSvg />
      </button>
    </div>
  )
}
